<template>
    <div>
        <h1
            v-if="title || editable"
            class="h4">
            <div
                v-if="editingTitle"
                class="row g-0 align-items-center">
                <pc-input
                    ref="titleInput"
                    v-model="titleWrapper"
                    v-bind:aria-label="titleInputPlaceholderText"
                    v-bind:placeholder="titleInputPlaceholderText"
                    v-bind:maxlength="128"
                    data-test-role="edit-form-title"
                    class="col-8 col-lg-6" />
                <pc-button
                    small
                    class="col-auto ms-1"
                    data-test-role="edit-form-title-button-close"
                    v-on:click="setEditingTitle(false)">
                    {{ closeEditorButtonLabel }}
                </pc-button>
            </div>
            <div
                v-else
                class="d-flex align-items-center"
                data-test-role="form-title"
                v-bind:class="titleClass">
                {{ displayTitle }}
                <pc-button
                    v-if="showEditTitle"
                    outline
                    small
                    style="min-width: 0"
                    class="ms-1"
                    data-test-role="edit-form-title-button-open"
                    v-bind:aria-label="titleEditButtonAriaLabel"
                    v-on:click="setEditingTitle(true)">
                    <pc-bs-icon
                        name="pencil-fill"
                        class="text-primary" />
                </pc-button>
            </div>
        </h1>
        <div v-if="subtitle || editable">
            <div
                v-if="editingSubtitle"
                class="row g-0 align-items-center">
                <pc-input
                    ref="subtitleInput"
                    v-model="subtitleWrapper"
                    v-bind:aria-label="subtitleInputPlaceholderText"
                    v-bind:placeholder="subtitleInputPlaceholderText"
                    v-bind:maxlength="128"
                    data-test-role="edit-form-subtitle"
                    class="col-8 col-lg-6" />
                <pc-button
                    small
                    class="col-auto ms-1"
                    data-test-role="edit-form-subtitle-button-close"
                    v-on:click="setEditingSubtitle(false)">
                    {{ closeEditorButtonLabel }}
                </pc-button>
            </div>
            <div
                v-else
                class="d-flex align-items-center ms-3"
                data-test-role="form-subtitle"
                v-bind:class="subtitleClass">
                {{ displaySubtitle }}
                <pc-button
                    v-if="showEditSubtitle"
                    outline
                    small
                    style="min-width: 0"
                    class="ms-1"
                    data-test-role="edit-form-subtitle-button-open"
                    v-bind:aria-label="subtitleEditButtonAriaLabel"
                    v-on:click="setEditingSubtitle(true)">
                    <pc-bs-icon
                        name="pencil-fill"
                        class="text-primary" />
                </pc-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { NAMESPACE, KEYS } from "./i18n/formTitleSubtitle.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        props: {
            title: { type: String, required: false, default: null },
            subtitle: { type: String, required: false, default: null },
            editable: { type: Boolean, required: false, default: false }
        },
        emits: ["edit-title", "edit-subtitle"],
        data() {
            return {
                editingTitle: false,
                editingSubtitle: false
            };
        },
        computed: {
            titleWrapper: {
                get() {
                    return this.title;
                },
                set(value) {
                    this.$emit("edit-title", value?.trim());
                }
            },
            subtitleWrapper: {
                get() {
                    return this.subtitle;
                },
                set(value) {
                    this.$emit("edit-subtitle", value?.trim());
                }
            },
            displayTitle() {
                if (this.editable && !this.title) {
                    return this.defaultDisplayTitleText;
                }
                return this.title;
            },
            displaySubtitle() {
                if (this.editable && !this.subtitle) {
                    return this.defaultDisplaySubtitleText;
                }
                return this.subtitle;
            },
            showEditTitle() {
                return this.editable && !this.editingTitle;
            },
            showEditSubtitle() {
                return this.editable && !this.editingSubtitle;
            },
            titleClass() {
                return { "fst-italic": !this.title };
            },
            subtitleClass() {
                return { "fst-italic": !this.subtitle };
            },
            ...mapI18n(KEYS, NAMESPACE)
        },
        methods: {
            async setEditingTitle(editing) {
                this.editingTitle = editing;
                if (editing) {
                    await this.$nextTick();
                    this.$refs.titleInput.$refs.input.focus();
                }
            },
            async setEditingSubtitle(editing) {
                this.editingSubtitle = editing;
                if (editing) {
                    await this.$nextTick();
                    this.$refs.subtitleInput.$refs.input.focus();
                }
            }
        }
    };
</script>
